class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeItems();
    });

    this.addEventListener("touchstart", (event) => {
      event.preventDefault();
      this.removeItems();
    });
  }

  removeItems() {
    if (!this.classList.contains("fls-cart__remove--removing")) {
      this.classList.add("fls-cart__remove--removing");
      var itemLine = this.closest("[data-index]").getAttribute("data-index");
      var itemToRemove = this.closest(".fls-cart__item");
      var idToRemove = itemToRemove.getAttribute("data-itemid");

      this.closest("cart-items").updateQuantity(
        itemLine,
        0,
        "remove",
        idToRemove
      );
    }
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!this.isLoading()) {
      this.updateQuantity(
        document.activeElement
          .closest("[data-index]")
          .getAttribute("data-index"),
        event.target.value,
        document.activeElement.getAttribute("name"),
        document.activeElement
          .closest("[data-itemid]")
          .getAttribute("data-itemid")
      );
    }
  }

  updateQuantity(line, quantity, name, itemid) {
    // console.log('updateQnt')
    // console.log('line:', line)
    // console.log('quantity:', quantity)
    // console.log('name:', name)
    // console.log('itemid:', itemid)

    // Validazione parametri
    if (line === "" || line === undefined) {
      return;
    }
    if (quantity === "" || quantity === undefined) {
      return;
    }
    if (name === "" || name === undefined) {
      return;
    }
    if (itemid === "" || itemid === undefined) {
      return;
    }

    // Show loading
    this.enableLoading(line);

    let isLinesToReset = false;

    // Body request HTTP
    const body = JSON.stringify({
      line,
      quantity,
    });

    // Call API change cart Shopify
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (+quantity <= 0) {
          const itemToRemove = document.querySelectorAll(
            '.fls-cart__item[data-itemid="' + itemid + '"]'
          );
          itemToRemove.forEach((item) => {
            removeFadingOut(item, 600);
          });
          isLinesToReset = true;
        }

        if (isLinesToReset) {
          this.resetItemsLines(parsedState.items);
          isLinesToReset = false;
        }

        // Mapping object proprieties

        const itemCount = parsedState.item_count; // 3
        const currency = parsedState.currency; // EUR
        const arrCartItems = parsedState.items; // array
        const itemsSubtotalPrice = parsedState.items_subtotal_price; // 220000
        const originalTotalPrice = parsedState.original_total_price; // 220000
        const totalPrice = parsedState.total_price; // 220000

        this.classList.toggle("cart-is-empty", parsedState.item_count === 0);

        const cartIcons = document.querySelectorAll(".svg-icon--cart");
        cartIcons.forEach(function (cartIcon) {
          cartIcon.classList.toggle(
            "svg-icon--cartfull",
            parsedState.item_count > 0
          );
        });

        const sidecartWrapper = document.querySelector(
          ".fls-sidecart__wrapper"
        );
        if (sidecartWrapper) {
          sidecartWrapper.classList.toggle(
            "cart-is-empty",
            parsedState.item_count === 0
          );
        }

        const cartSubtitle = document.querySelector(".fls-hide-empty-cart");
        if (cartSubtitle) {
          cartSubtitle.classList.toggle(
            "cart-is-empty",
            parsedState.item_count === 0
          );
        }

        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        // Element to update
        var itemToUpdate = this.getItemToUpdate(itemid, arrCartItems);

        // Update cart item
        this.updateCartItem(itemToUpdate);

        // Update quantity input
        this.updateQuantityInput(itemToUpdate);

        // Update cart total price
        this.updateCartTotalPrice(itemsSubtotalPrice, totalPrice);

        // Update items quantity cart
        this.updateItemsQtaCart(itemCount);

        this.disableLoading();
      })
      .catch((e) => {
        console.log("***ERROR***");
        console.log(e);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        // document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
        // location.reload();
      });
  }

  getItemToUpdate(itemid, arrCartItems) {
    if (itemid == "" || itemid == undefined) {
      return;
    }
    if (!arrCartItems || arrCartItems.length <= 0) {
      return;
    }
    var result = arrCartItems.filter(function (obj) {
      return obj.id == itemid;
    });

    return result ? result[0] : null;
  }

  updateCartItem(itemToUpdate) {
    if (itemToUpdate == "" || itemToUpdate == undefined) {
      return;
    }

    const id = itemToUpdate.id;
    const finalLinePrice = itemToUpdate.final_line_price;
    const itemPrice = document.querySelectorAll(
      '.item-price[data-itemid="' + id + '"]'
    );
    const itemOriginalPrice = document.querySelectorAll(
      '.item-price--old[data-itemid="' + id + '"]'
    );
    let discount;

    if (itemOriginalPrice.length > 0) {
      const itemCompareAtPrice = parseInt(
        document
          .querySelector('.item-price--old[data-itemid="' + id + '"]')
          .getAttribute("data-original-price")
      );
      const itemPriceNew = parseInt(
        document
          .querySelector('.item-price[data-itemid="' + id + '"]')
          .getAttribute("data-price")
      );
      discount = String(100 - (itemPriceNew / itemCompareAtPrice) * 100);
    }

    itemPrice.forEach((price) => {
      const Prezzo = Shopify.formatMoney(
        finalLinePrice,
        shopCurrencySymbol + "{{ amount_with_comma_separator }}"
      );
      price.innerHTML =
        discount != undefined
          ? `<span style="font-size:12px">` +
            discount +
            "% OFF - " +
            `</span>` +
            Prezzo
          : Prezzo;
    });

    if (itemOriginalPrice) {
      itemOriginalPrice.forEach((originalPrice) => {
        if (+originalPrice.getAttribute("data-original-price") > 0) {
          originalPrice.innerHTML = Shopify.formatMoney(
            +originalPrice.getAttribute("data-original-price") *
              itemToUpdate.quantity,
            shopCurrencySymbol + "{{ amount_with_comma_separator }}"
          );
        }
      });
    }
  }

  updateCartTotalPrice(subtotalPrice, totalPrice) {
    if (subtotalPrice == "" || subtotalPrice == undefined) {
      return;
    }
    if (totalPrice == "" || totalPrice == undefined) {
      return;
    }

    var subtotalPriceCart = document.querySelectorAll(
      ".fls-cart-aside__subtotal-price"
    );
    subtotalPriceCart.forEach(
      (subtotal) =>
        (subtotal.innerHTML = Shopify.formatMoney(
          subtotalPrice,
          shopCurrencySymbol + "{{ amount_with_comma_separator }}"
        ))
    );

    var totalPriceCart = document.querySelectorAll(
      ".fls-cart-aside__total-price"
    );
    totalPriceCart.forEach(
      (total) =>
        (total.innerHTML = Shopify.formatMoney(
          totalPrice,
          shopCurrencySymbol + "{{ amount_with_comma_separator }}"
        ))
    );
  }

  updateItemsQtaCart(itemsTotalQta) {
    document.querySelectorAll(".icon--carfull-counter").forEach((icon) => {
      if (itemsTotalQta > 0) {
        icon.innerHTML = itemsTotalQta;
      } else {
        icon.innerHTML = "";
      }
    });
  }

  updateQuantityInput(itemToUpdate) {
    if (itemToUpdate == "" || itemToUpdate == undefined) {
      return;
    }

    const id = itemToUpdate.id;
    const quantity = itemToUpdate.quantity;

    const quantityInput = document.querySelectorAll(
      'quantity-input[data-itemid="' + id + '"] > input'
    );

    const setMaxQnt = (max) => {
      quantityInput.forEach((qnt) => qnt.setAttribute("max", max));
    };

    const setMaxReached = () => {
      quantityInput.forEach((qnt) =>
        qnt.parentElement.classList.add(
          "fls-cart__quantity-input-wr--max-reached"
        )
      );
    };

    const removeMaxReached = () => {
      quantityInput.forEach((qnt) =>
        qnt.parentElement.classList.remove(
          "fls-cart__quantity-input-wr--max-reached"
        )
      );
    };

    quantityInput.forEach((qnt) => {
      if (!qnt.getAttribute("max") && qnt.value > quantity) {
        setMaxQnt(quantity);
      }

      qnt.value = quantity;
      qnt.setAttribute("value", quantity);

      qnt.value === qnt.getAttribute("max")
        ? setMaxReached()
        : removeMaxReached();
    });
  }

  resetItemsLines(cartItems) {
    if (!cartItems) {
      return;
    }

    const cartDOMItems = document.querySelectorAll(".fls-cart__item");

    cartDOMItems.forEach((item) => {
      const itemId = item.getAttribute("data-itemid");

      const newLine = cartItems.findIndex(
        (cartItem) => +cartItem.id === +itemId
      );

      if (newLine >= 0) {
        item.setAttribute("data-index", 1 + newLine);
        item
          .querySelector("cart-remove-button")
          .setAttribute("data-index", 1 + newLine);
      }
    });
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items-2")
      .classList.add("cart__items--disabled");
    if (document.getElementById("main-cart-items")) {
      document
        .getElementById("main-cart-items")
        .classList.add("cart__items--disabled");
    }

    const quantityBtn = document.querySelectorAll(".fls-cart__quantity-btn");
    quantityBtn.forEach((qnt) => (qnt.disabled = true));

    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById("main-cart-items-2")
      .classList.remove("cart__items--disabled");
    if (document.getElementById("main-cart-items")) {
      document
        .getElementById("main-cart-items")
        .classList.remove("cart__items--disabled");
    }

    const quantityBtn = document.querySelectorAll(".fls-cart__quantity-btn");
    quantityBtn.forEach((qnt) => (qnt.disabled = false));
  }

  isLoading() {
    return !!document.querySelector("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);
